import React, { Component } from "react"
import { connect } from 'react-redux'
import { createStructuredSelector } from "reselect"
import { DisplayDate } from "controls/display_date"
import { VerifyBadgeDialog } from "./verify_badge_dialog"

const _get = (path, object) =>
  path.reduce((xs, x) =>
    (xs && xs[x]) ? xs[x] : null, object);

const or = (defaultValue, x) => x || defaultValue;

const get = (defaultValue, path, object) =>
  or(defaultValue, _get(path, object));

const GET_BADGE_SUCCESS = 'GET_BADGE_SUCCESS';
const DEFAULT_IMAGE = 'https://credlyapp.s3.amazonaws.com/avatars/fbe5d8cb03489a142fe90d12bb7e7c32_19.png';

function getBadge(id) {
  return dispatch => {
    dispatch(getBadgeSuccess((window._badge) ? window._badge : {}));
  };
}

function getBadgeSuccess(json) {
  return {
    type: GET_BADGE_SUCCESS,
    json
  }
}

class BadgeDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false
    };
  }

  componentDidMount() {
    this.props.getBadge(this.props.match.params.id)
  }

  renderSkill(skill, i) {
    return (
      <li key={i}>{get('', ['name'], skill)}</li>
    );
  }

  getAsHtml(path, obj) {
    return {
      __html: get('',path, obj)
    };
  }

  showDialog = () => this.setState({ showDialog: true });

  hideDialog = () => this.setState({ showDialog: false });

  renderDialog() {
    return (<VerifyBadgeDialog badge={this.props.badge} hideDialog={this.hideDialog} />);
  }

  render() {
    let badge = this.props.badge;
    let skills = null;
    let categories = get([], ['categories'], badge);
    let issuedAt = get('',  ['issued_at'], badge);
    let issuedDate = null;

    if (issuedAt) {
      issuedDate = (
        <span>{" "}on{" "}<DisplayDate date={issuedAt} /></span>
      );
    }

    if (categories.length) {
      skills = (
        <div className="badge-details__detail-section">
          <h3 className="badge-details__detail-section-heading">Demonstrated Skills</h3>
          <ul className="badge-details__skills">
            {categories.map((skill, i) => this.renderSkill(skill, i))}
          </ul>
        </div>
      );
    }

    return (
      <div>
        <div className="badge-details__banner">
          <div className="badge-details__banner-inner container">
            <div className="badge-details__section hide-mobile">
              <div className="badge-banner-image">
                <img alt={get('', ['member', 'display_name'], badge)} className="badge-banner-image__profile-image" src={get(DEFAULT_IMAGE,['member', 'avatar'], badge)} />
              </div>
            </div>
            <div className="badge-details__section badge-details__section-details">
              <p>This badge was issued to <strong>{get('', ['member', 'display_name'], badge)}</strong>{issuedDate}.</p>
            </div>
            <div className="badge-details__section">
              <div className="badge-details-manage">
                <div className="badge-details-manage__actions">
                  <button className="c-button c-button__primary" type="button" aria-label="Verify" onClick={this.showDialog}>
                    <div className="c-button__content">Verify</div>
                  </button>
                  { this.state.showDialog && this.renderDialog() }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="badge-details container">
          <div className="badge-details__body">
            <div className="row">
              <div className="col-12 col-md-4">
                <img className="badge-details__image" src={get(DEFAULT_IMAGE,['image'], badge)} />
              </div>
              <div className="col-12 col-md-8">
                <div className="badge-details__basic-info">
                  <h2 className="badge-details__name">{get(DEFAULT_IMAGE,['title'], badge)}</h2>
                  <div className="badge-details__issuer">
                    Issued by {get(DEFAULT_IMAGE,['issuer', 'display_name'], badge)}
                  </div>
                </div>
                <div className="badge-details__detail-section rendered-html" dangerouslySetInnerHTML={this.getAsHtml(['description'], badge)}>
                </div>
                {skills}
                <div className="badge-details__detail-section">
                  <h3 className="badge-details__detail-section-heading">Earning Criteria</h3>
                  <div className="rendered-html" dangerouslySetInnerHTML={this.getAsHtml(['criteria'], badge)}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="badge-details container">
          <div className="badge-details__body">
            <div className="row">
              <div className="col-12">
                <div className="badge-details__owner-actions">
                  <a href="https://support.credly.com/hc/en-us/requests/new" target="_blank">Request Deletion</a>
                  { false && " | "}
                  { false && (<a onClick={this.downloadBakedBadge}>Download Open Badge</a>) }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const structuredSelector = createStructuredSelector({
  badge: state => state.badge,
});

const mapDispatchToProps = { getBadge };

export default connect(structuredSelector, mapDispatchToProps)(BadgeDetails);
